/**
 * Appends a timestamped debug message to the debugging log element on the page.
 * Safely writes to the DOM by appending text content directly to an element
 * with the ID `debug-log`. If the element does not exist, the function returns early.
 *
 * @param msg - The message to log for debugging purposes.
 * @returns {void}
 */
export function logDebug(msg: string): void {
    const box = document.getElementById('debug-log');
    if (!box) return;
    const time = new Date().toLocaleTimeString();
    box.textContent += `[${time}] ${msg}\n`;
    box.scrollTop = box.scrollHeight;
}
